import { BlogCardProps } from '@/components/card/types';
import { getCardPath } from '@/utils/get-post-path';
import { CardStrapi } from '@/strapi-types';
import { contentTypeMap, ContentTypes } from './get-content-type';

export interface MapCardType extends CardStrapi {
  locale: string;
  type: ContentTypes;
}

function createBlogCard(
  contentItem: MapCardType,
  typeTitle: string,
): BlogCardProps {
  const { locale, type, duration, title, shortExcerpt, mainImage, categories } =
    contentItem;
  const categoryItems = Array.isArray(categories)
    ? categories
    : categories?.data || [];

  return {
    variant: 'blog',
    type: {
      icon: { name: 'pen-tool' },
      title: typeTitle,
      duration,
    } as unknown as any,
    title,
    description: [
      {
        type: 'paragraph',
        children: [
          {
            text: String(shortExcerpt?.[0]?.children?.[0]?.text || ''),
            type: 'text',
          },
        ],
      },
    ],
    image: {
      image: mainImage,
      classNameImage: 'w-full h-full object-top',
    },
    badge: categoryItems.map((item) => ({
      variant: item.variant || 'ice-blue',
      title: item.title,
    })),
    link: {
      href: getCardPath(locale, type, contentItem),
      title: locale === 'de' ? 'Mehr lesen' : 'Read More',
      rightIcon: { name: 'chevron-right' },
    },
  };
}

export function mapCardProps(
  contentItem: MapCardType,
): BlogCardProps | undefined {
  const typeTitle = contentTypeMap[contentItem.type];
  if (!typeTitle) {
    console.error(
      `Unknown content type: ${contentItem.type} for ${contentItem.slug}`,
    );
    return undefined;
  }

  return createBlogCard(contentItem, typeTitle.singular);
}
